"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var components_1 = require("components");
var styles = __importStar(require("./Transcript.module.css"));
var Transcript = (function (_super) {
    __extends(Transcript, _super);
    function Transcript(props) {
        return _super.call(this, props) || this;
    }
    Transcript.prototype.render = function () {
        var _a = this.props, json_data = _a.json_data, onChange = _a.onChange, errors = _a.errors, _b = _a.transcript, title = _b.title, identifier = _b.identifier, address = _b.address, city = _b.city, attn = _b.attn, fax = _b.fax, className = _a.className;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("ul", { className: styles.sectionSubList },
                react_1.default.createElement("li", { className: styles.sectionListChild },
                    react_1.default.createElement(components_1.CheckBox, { id: identifier, errors: errors, json_data: json_data, onChange: onChange, className: className }),
                    react_1.default.createElement("p", null,
                        react_1.default.createElement("strong", null, title)),
                    react_1.default.createElement("p", null, address),
                    react_1.default.createElement("p", null, city),
                    react_1.default.createElement("p", null,
                        react_1.default.createElement("strong", null, "Attn:"),
                        " ",
                        attn)))));
    };
    return Transcript;
}(react_1.Component));
exports.default = Transcript;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVHJhbnNjcmlwdC5qcyIsInNvdXJjZVJvb3QiOiIuLyIsInNvdXJjZXMiOlsicGRmL2Zvcm1zL2ludGVsbGl0ZWMvRW5yb2xsZW1udFBhY2tldEluZm9fNF82L3BhcnRzL1NlY3Rpb243L1RyYW5zY3JpcHQvVHJhbnNjcmlwdC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLDZDQUFzQztBQUV0Qyx5Q0FBbUM7QUFDbkMsOERBQWlEO0FBVWpEO0lBQXdDLDhCQUFvQjtJQUN4RCxvQkFBWSxLQUFLO2VBQ2Isa0JBQU0sS0FBSyxDQUFDO0lBQ2hCLENBQUM7SUFFRCwyQkFBTSxHQUFOO1FBQ1UsSUFBQSxlQU1RLEVBTFYsd0JBQVMsRUFDVCxzQkFBUSxFQUNSLGtCQUFNLEVBQ04sa0JBQXlELEVBQTVDLGdCQUFLLEVBQUUsMEJBQVUsRUFBRSxvQkFBTyxFQUFFLGNBQUksRUFBRSxjQUFJLEVBQUUsWUFBRyxFQUN4RCx3QkFDVSxDQUFBO1FBRWQsT0FBTyxDQUNILDhCQUFDLGVBQUssQ0FBQyxRQUFRO1lBQ1gsc0NBQUksU0FBUyxFQUFFLE1BQU0sQ0FBQyxjQUFjO2dCQUNoQyxzQ0FBSSxTQUFTLEVBQUUsTUFBTSxDQUFDLGdCQUFnQjtvQkFDbEMsOEJBQUMscUJBQVEsSUFDTCxFQUFFLEVBQUUsVUFBVSxFQUNkLE1BQU0sRUFBRSxNQUFNLEVBQ2QsU0FBUyxFQUFFLFNBQVMsRUFDcEIsUUFBUSxFQUFFLFFBQVEsRUFDbEIsU0FBUyxFQUFFLFNBQVMsR0FDdEI7b0JBQ0Y7d0JBQ0ksOENBQVMsS0FBSyxDQUFVLENBQ3hCO29CQUNKLHlDQUFJLE9BQU8sQ0FBSztvQkFDaEIseUNBQUksSUFBSSxDQUFLO29CQUNiO3dCQUNJLHNEQUFzQjs7d0JBQUUsSUFBSSxDQUM1QixDQUNILENBQ0osQ0FDUSxDQUNwQixDQUFBO0lBQ0wsQ0FBQztJQUNMLGlCQUFDO0FBQUQsQ0FBQyxBQXRDRCxDQUF3QyxpQkFBUyxHQXNDaEQifQ==